//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';

export default {
  name: 'Kickboxing_Workouts',
  components: {
    FCImage,
  },
  data() {
    return {
      workouts: [
        {
          id: 1,
          title: 'Shanie Kickboxing Workout',
          imgUrl: 'v4/fc-fullbody-shanie-kickboxing-workout-001.png',
          altText: 'Trainer Shanie Smash Kicking the free standing bag',
        },
        {
          id: 2,
          title: 'Fullbody Kickboxing Workout',
          imgUrl: 'v4/fc-fullbody-kickboxing-workout-001.png',
          altText: 'Trainer Aaron Swenson kicking the free standing bag with leopard print shorts',
        },
        {
          id: 3,
          title: 'Kickboxing Workout',
          imgUrl: 'v4/fc-kickboxing-workout-001.png',
          altText: 'Trainer Flo kicking the free standing bag',
        },
        {
          id: 4,
          title: 'Kickboxing With Aaron Workout',
          imgUrl: 'v4/fc-kickboxing-with-aaron-workout-001.png',
          class: 'kickboxing-workouts-hide',
          altText: 'Trainer Aaron Swenson kicking the air',
        },
        {
          id: 5,
          title: 'Pure Striking Workout',
          imgUrl: 'v4/fc-pure-stricking-kickboxing-workout-001.png',
          class: 'kickboxing-workouts-hide',
          altText: 'Trainer Shanie Smash kicking the air',
        },
      ],
    };
  },
};
